// extracted by mini-css-extract-plugin
export default {"sticky-header":"StickyHeader_sticky-header__g61Zz"};